import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { NoEulaGuard } from '@lsq-frontend/fasttrack-shared/features/eula-service';
import {
    supplyChainDirectAtlas,
    supplyChainDirectNode
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { AuthorizationGuard, ClaimGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import { SupplyChainDirectComponent } from './supply-chain-direct.component';

export const financingRoutes: Routes = [
    {
        path: UiRoutes.Home,
        component: SupplyChainDirectComponent,
        canActivate: [AuthorizationGuard, NoEulaGuard],
        data: {
            title: supplyChainDirectNode.title
        },
        children: [
            {
                path: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_SELLER.path,
                canActivate: [ClaimGuard],
                data: {
                    title: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_SELLER.title,
                    claims: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_SELLER.claims
                },
                loadChildren: () =>
                    import('./seller/supply-chain-direct-seller.module').then(
                        (mod) => mod.SupplyChainDirectSellerModule
                    )
            },
            {
                path: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_BUYER.path,
                canActivate: [ClaimGuard],
                data: {
                    title: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_BUYER.title,
                    claims: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_BUYER.claims
                },
                loadChildren: () =>
                    import('./buyer-account/buyer/supply-chain-direct-buyer.module').then(
                        (mod) => mod.SupplyChainDirectBuyerModule
                    )
            },
            {
                path: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT.path,
                canActivate: [ClaimGuard],
                data: {
                    title: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT.title,
                    claims: supplyChainDirectAtlas.SUPPLY_CHAIN_DIRECT_ACCOUNT.claims
                },
                loadChildren: () =>
                    import('./buyer-account//account/supply-chain-direct-account.module').then(
                        (mod) => mod.SupplyChainDirectAccountModule
                    )
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(financingRoutes)],
    exports: [RouterModule]
})
export class SupplyChainDirectRoutingModule {}
